module.exports = __webpack_public_path__ + "static/media/feature-big-data.328324d5.svg";